import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {withRouter} from 'react-router';

import NewsMenuItem from './NewsMenuItem.js';

const NewsMenu = ({ clang, items }) => {
    return (
        <div className="news__menu">
            <h2 className="news__menu-categories">
                {lang[clang].news.categories}
            </h2>
            <span className="news__menu-categories--line"></span>
            <ul className="news__menu-list">
                {items.map(item =>
                    <NewsMenuItem key={item.id} {...item}/>)}
            </ul>
        </div>
    );
};

NewsMenu.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(NewsMenu));



// WEBPACK FOOTER //
// ./src/components/news/NewsMenu.js